export default __webpack_public_path__ + "assets/images/decor.254d9b.webp";